import React, { useRef } from 'react'
import emailjs from "@emailjs/browser";


function Contact() {

  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault(); // prevent page reload

    // Send email via EmailJS
    emailjs
      .sendForm(
        "service_bgh4cm2", // EmailJS Service ID
        "template_f6b1dhc", // EmailJS Template ID
        formRef.current,
        "q13BP6L2yKDgfSf7B" // EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Thank You for contacting us. We will get back to you soon!");
          formRef.current.reset(); // reset form
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div
      style={{
        borderLeft: "150px solid  #0C2B4B",   // left border 
        borderRight: "150px solid #0C2B4B",  // right border    
        height: "100vh",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // padding: "40px 150px",
        // boxSizing: "border-box"
      }}
    >
      <div>{/* Contact Start */}
        <div className="container-xxl py-6">
          <div className="container">
            <div className="row g-5">
              {/* <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s" style={{minHeight: '450px'}}>
              <div className="position-relative h-100">
              <iframe  className="position-relative w-100 h-100" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.9497274243886!2d72.8568604!3d19.284552299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b04bf78d57eb%3A0x1ec36cf3505a28ea!2sST.%20HARIS%20HIGH%20SCHOOL!5e0!3m2!1sen!2sin!4v1596707054275!5m2!1sen!2sin"  frameBorder={0} style={{minHeight: '450px', border: 0}} allowFullScreen aria-hidden="false" tabIndex={0} />
              </div>
            </div> */}
              <div style={{ width: "200%", maxWidth: "900px" }} data-wow-delay="0.5s">
                {/* <h6 className="text-primary text-uppercase mb-2">Contact Us</h6> */}
                <h1 className="display-6 mb-4"><u>Contact Us</u></h1>
                <form ref={formRef}
                  onSubmit={sendEmail}
                  // action="https://docs.google.com/forms/d/e/YOUR_GOOGLE_FORM_ID/formResponse"
                  method="POST"
                  target="_blank">
                  <div className="row g-3">
                    {/* <h6 className="text-primary text-uppercase mb-2">Enquire To Us</h6> */}
                    <div className="col-md-12">
                      <div className="form-floating">
                        <input type="text" className="form-control border-0 bg-light" id="name" name="name" placeholder="Your Name" required />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-floating">
                        <input type="comp_name" className="form-control border-0 bg-light" id="comp_name" name="comp_name" placeholder="Business Name" />
                        <label htmlFor="comp_name">Business Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input type="email" className="form-control border-0 bg-light" id="email" name="email" placeholder="Your Email" />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input type="phone" className="form-control border-0 bg-light" id="phone" name="phone" placeholder="Your Phone" required />
                        <label htmlFor="phone">Your Phone</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input type="text" className="form-control border-0 bg-light" id="subject" name="subject" placeholder="Subject" />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea className="form-control border-0 bg-light" placeholder="Leave a message here" id="message"
                          name="message" style={{ height: '150px' }} defaultValue={""} required />
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button className="btn btn-primary py-3 px-5" type="submit">Submit</button>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}</div>
  )
}

export default Contact